export { default } from './RibbonCheckTwo'
